












































































import Vue from 'vue'
import Component from 'vue-class-component'
import { EOrigin } from '@zunta/configurations'
import ModalV2 from '@/components/modals/ModalV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { ISelectItem } from '@/interfaces'

@Component({
  components: {
    InputValidator,
    InputV2,
    SelectV2,
    ModalV2
  },
  props: {
    origin: {
      type: String,
      default: ''
    }
  }
})
export default class AddFacilityModal extends Vue {
  billingSoftware: string = ''
  facilityName: string = ''
  directory: string = ''
  originid: string = ''

  validations (): any {
    return {
      billingSoftware: {
        required
      },
      facilityName: {
        required: requiredIf(() => this.billingSoftware === EOrigin.NCS)
      },
      directory: {
        required: requiredIf(() => this.billingSoftware === EOrigin.NCS && !this.originid)
      },
      originid: {
        required: requiredIf(() => this.billingSoftware === EOrigin.NCS && !this.directory)
      }
    }
  }

  get isNcs () {
    return this.billingSoftware === EOrigin.NCS
  }

  get disableSelect () {
    return !this.$props.origin
  }

  get billingSoftwareItems () {
    const options:ISelectItem[] = Object.values(EOrigin)
      .filter((item: string) => item !== EOrigin.MANUAL)
      .map((item: string) => {
        return {
          key: item,
          value: item,
          content: item
        }
      })
    return options.filter((option: ISelectItem) => {
      if (this.$props.origin === 'BOTH') {
        return option.value !== 'BOTH'
      }
      return this.$props.origin === option.value
    })
  }

  onAddFacility () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    this.$emit('submit', {
      billingSoftware: this.billingSoftware,
      facilityName: this.facilityName,
      directory: this.directory,
      originid: this.originid
    })
  }
}
